import { Component } from '@angular/core';
import { SettingsOption } from 'src/app/enums/settings';
import { PermissionsService } from 'src/app/services/permissions.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-settings',
    templateUrl: './settings.component.html',
    styleUrls: ['./settings.component.scss']
})
export class SettingsComponent {
    readonly SettingsOption = SettingsOption;
    selectedComponent!: SettingsOption;
    env = environment;

    componentMapping: Record<SettingsOption, string> = {
        [SettingsOption.TIPURI_AMENZI]: 'app-tipuri-amenzi',
        [SettingsOption.TIPURI_TAXE_NEDEBITATE]: 'app-tipuri-taxe-nedebitate',
    };
    componentKeys: string[] = Object.keys(this.componentMapping);

    onChange($event: { value: any }) {
        this.selectedComponent = $event.value;
    }

    selectedSection: any = null;

    constructor(public permissionsService: PermissionsService) { }
}
